var map = {
	"./401_AccessDenied.svg": 541,
	"./404_PageNotFound.svg": 542,
	"./Empty_container.svg": 543,
	"./No_result_found.svg": 343,
	"./coming_soon.svg": 544,
	"./regenerate.svg": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;